const link_list = {
    routePath: 'applications',
    actionName: 'open-application',
    iconClass: 'fa-solid fa-calendar-check',
    title: 'Open Application',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: '',
}
export default {link_list }